import styled from "styled-components";

const StyledVideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  grid-gap: .5rem;
  /*background-color: #E1E327;*/

`

export default StyledVideoGrid